import React from 'react';
import ConspiracyCard from './ConspiracyCard';
import Shadows from './Shadows';

function CardInfo(props) {
    let card = props.selectedCard;
    return (
        <div className="info-board">
            <button className="go-back" onClick={props.selectCard.bind(null, null)}>&laquo; Back to the Board</button>
            <div className="half">
                <div className="card-info-container">
                    <svg width="100%" viewBox="0 0 400 450">
                        <Shadows />
                        <ConspiracyCard card={card} x="10" y="25" height={card.height * 2} width={card.width * 2} rotate="-3" />
                    </svg>
                </div>
            </div>
            <div className="half">
                <div className="card-information">
                    <div className="card-text" dangerouslySetInnerHTML={{__html: card.information}} />
                </div>
            </div>
        </div>
    )
}

export default CardInfo;


// WEBPACK FOOTER //
// ./src/components/CardInfo.js